import clsx from 'clsx'
import PropTypes from 'prop-types'

export default function CareerBadge({ title, onClick, isSelected }) {
  return (
    <div
      key={title}
      onClick={onClick}
      className={clsx(
        'cursor-pointer rounded-full px-2.5 py-2 text-xs font-semibold',
        isSelected
          ? 'border border-primaryBlue bg-primaryBlue text-white'
          : 'border border-lightBlue bg-paleWhiteBlue text-darkBlue'
      )}
    >
      {title}
    </div>
  )
}

CareerBadge.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired
}
